import { Box, Pagination, useTheme } from '@mui/material'

export interface ConfigurationsListPaginationProps {
    show: boolean;
    itemCount: number;
    pageSize: number;
    page: number;
    onPageChange: (newPage: number) => void;
}

export const ConfigurationsListPagination = ({
    show, itemCount, pageSize, page, onPageChange
}: ConfigurationsListPaginationProps) => {

    const theme = useTheme();

    const count = Math.ceil(itemCount / pageSize);

    return (
        <Box
            sx={{
                height: show ? '40px' : 0,
                padding: '6px 0 0 0',
                margin: '0 0 -8px 0',
                overflow: 'hidden',
                borderTop: show ? `1px solid ${theme.palette.action.disabled}` : undefined,
                alignContent: 'center',
            }}
        >
            {show &&
                <Pagination
                    id='configurations-pagination'
                    count={count}
                    size='medium'
                    sx={{
                        "& > .MuiPagination-ul": { justifyContent: "center" }
                    }}
                    page={page}
                    boundaryCount={6}
                    onChange={(_, value) => onPageChange(value)}
                />
            }
        </Box>
    )
}
